/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Rename_ActionInputs */

const en_us2_plan_rename_action = /** @type {(inputs: Plan_Rename_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rename workout`)
};

const pt_br2_plan_rename_action = /** @type {(inputs: Plan_Rename_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renomear treino`)
};

const es_419_plan_rename_action = /** @type {(inputs: Plan_Rename_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renombrar entrenamiento`)
};

const pt_pt2_plan_rename_action = /** @type {(inputs: Plan_Rename_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mudar o nome do treino`)
};

const fr_fr2_plan_rename_action = /** @type {(inputs: Plan_Rename_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renommer la séance`)
};

const de_de2_plan_rename_action = /** @type {(inputs: Plan_Rename_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training umbenennen`)
};

const it_it2_plan_rename_action = /** @type {(inputs: Plan_Rename_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rinomina allenamento`)
};

/**
* | output |
* | --- |
* | "Rename workout" |
*
* @param {Plan_Rename_ActionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_rename_action = /** @type {((inputs?: Plan_Rename_ActionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Rename_ActionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_rename_action(inputs)
	if (locale === "es-419") return es_419_plan_rename_action(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_rename_action(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_rename_action(inputs)
	if (locale === "de-DE") return de_de2_plan_rename_action(inputs)
	if (locale === "it-IT") return it_it2_plan_rename_action(inputs)
	return en_us2_plan_rename_action(inputs)
});
export { plan_rename_action as "plan.rename_action" }